import { useRef, useState } from 'react';

export const useActivityUI = () => {
  const [isHover, setIsHover] = useState(false);
  const [isOptionOpen, setIsOptionOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleHover = () => setIsHover(true);
  const handleLeave = () => setIsHover(false);
  const handleOptionClick = () => setIsOptionOpen((prev) => !prev);

  const handleOutsideClick = (isOutsideClicked: boolean) => {
    if (isOutsideClicked && isOptionOpen) {
      setIsOptionOpen(false);
    }
  };

  const handleClickOption = (callback: (argId: number) => void, activityId: number) => {
    callback(activityId);
    setIsOptionOpen(false);
  };

  return {
    isHover,
    isOptionOpen,
    wrapperRef,
    handleHover,
    handleLeave,
    handleOptionClick,
    handleOutsideClick,
    handleClickOption,
    setIsOptionOpen,
  };
};
